/**
 * Product Option Resource Client Side Helpers
 */

import { type RequiredNonNullable } from '../../../../../@types/build';
import { isPresent } from '../../../../utils/array/filter.utils';
import { type ProductOptionFieldsFragment, type ProductResourceFieldsFragment } from '../../../__generated__/graphql-client-types';

/**
 * Retrieve resources of all the options passed by parameter
 * This function will filter out those resources considered invalid
 * {@see resolveResource()}
 */
export const getProductResourcesByOptions = (
	options: ProductOptionFieldsFragment[]
): RequiredNonNullable<ProductResourceFieldsFragment>[] => {
	return options.map(({ resource }) => (resource ? resolveProductResource(resource) : null)).filter(isPresent);
};

/**
 * Validates an option resource if the given resource contains all product information.
 * Otherwise, null is returned.
 */
export const resolveProductResource = (
	resource: ProductResourceFieldsFragment
): RequiredNonNullable<ProductResourceFieldsFragment> | null => {
	const { variantId, brandName, modelNumber, url, status, price, finishes } = resource;
	if (variantId && brandName && modelNumber && url && price && status && finishes.length > 0) {
		const __typename = resource.__typename || 'ProductResource';
		const quantity = resource.quantity || 1;
		const rating = resource.rating || { ratingValue: 0, reviewCount: 0 };
		return { ...resource, __typename, variantId, brandName, modelNumber, url, price, finishes, status, quantity, rating };
	}
	return null;
};
